// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/transfer/style/index.less
// module id = 1928
// module chunks = 0